import { Link } from 'react-router-dom'

import { AuthScreenLayout } from '../components/auth/AuthScreenLayout'
import { LegalDocumentBody } from '../legal/content/LegalDocumentBody'
import { privacyPolicySections } from '../legal/content/privacyPolicy'
import {
  PERSONAL_DATA_CONSENT_DOCUMENT_VERSION,
  PERSONAL_DATA_CONSENT_OPERATOR,
} from '../legal/personalDataConsent'
import { PRIVACY_POLICY_EXTERNAL_URL } from '../legal/publicOffer'

/**
 * Адрес остался прежним — на него ведут ссылки из старых писем и форм, — но показывает он
 * теперь сам документ, а не пересказ. Раньше здесь висела заметка на два абзаца, которая
 * утверждала, что клиент идентифицируется по ИНН из десяти цифр: продукт перешёл на ОГРН,
 * заметка осталась.
 */
export const PersonalDataConsentLegalScreen = () => (
  <AuthScreenLayout variant="register">
    <article className="market-auth__card market-auth__card--register market-legal-doc">
      <header className="market-auth__card-header market-auth__card-header--compact">
        <h1 className="market-auth__card-title market-auth__card-title--compact">
          Политика конфиденциальности
        </h1>
        <p className="market-auth__card-lead market-auth__card-lead--compact">
          Редакция {PERSONAL_DATA_CONSENT_DOCUMENT_VERSION} ·{' '}
          {PERSONAL_DATA_CONSENT_OPERATOR.sites} · Постоянный адрес:{' '}
          <a href={PRIVACY_POLICY_EXTERNAL_URL} target="_blank" rel="noreferrer">
            provisium.ru/privacy
          </a>
        </p>
      </header>

      <div className="market-legal-doc__body">
        <LegalDocumentBody sections={privacyPolicySections} />
      </div>

      <p className="market-legal-doc__back">
        <Link className="market-auth__signup-link" to="/register">
          ← Вернуться к регистрации
        </Link>
      </p>
    </article>
  </AuthScreenLayout>
)
